import React from 'react';
import * as R from 'ramda';
import qs from 'qs';
import { Link } from 'gatsby';
import {
  getLocalisationFromPropertyObject,
  getCorrectPropertyObject,
} from '../utils';
import Image from './Image';

const PropertiesRoll = ({
  properties,
  propertyObject,
  queryFilters,
  featuredImage,
  location,
}) => {
  const urlParam = qs.parse(location.search, { ignoreQueryPrefix: true });
  const renderViewAll = () => {
    if (!R.isEmpty(queryFilters)) {
      return (
        <div className='column is-4'>
          <Link
            to={`${getLocalisationFromPropertyObject(
              propertyObject
            )}/portfolio?type=all`}>
            <Image
              imageInfo={{ image: featuredImage }}
              classes='property-roll-image'
              animationClass='hover-zoom'
            />
            <h4 className='portfolio-roll-title title'>VIEW ALL...</h4>
          </Link>
        </div>
      );
    }
  };

  const mappedProperties = properties.map(
    (property, index) =>
      index < 5 && (
        <div className='column is-4' key={property.node.frontmatter.title}>
          <Link
            to={`${getLocalisationFromPropertyObject(propertyObject)}${
              property.node.fields.slug
            }`}>
            <Image
              imageInfo={{ image: property.node.frontmatter.featuredImage }}
              classes='property-roll-image'
              animationClass='hover-zoom'
            />
            <h4 className='portfolio-roll-title title'>
              {property.node.frontmatter.title}
            </h4>
            <div className='portfolio-description'>
              {
                getCorrectPropertyObject(
                  property.node.frontmatter,
                  propertyObject
                ).short_description
              }
            </div>
          </Link>
        </div>
      )
  );
  const allMappedProperties = properties.map((property) => (
    <div className='column is-4' key={property.node.frontmatter.title}>
      <Link
        to={`${getLocalisationFromPropertyObject(propertyObject)}${
          property.node.fields.slug
        }`}>
        <Image
          imageInfo={{ image: property.node.frontmatter.featuredImage }}
          classes='property-roll-image'
          animationClass='hover-zoom'
        />
        <h4 className='portfolio-roll-title title'>
          {property.node.frontmatter.title}
        </h4>
        <div className='portfolio-description'>
          {
            getCorrectPropertyObject(property.node.frontmatter, propertyObject)
              .short_description
          }
        </div>
      </Link>
    </div>
  ));
  return (
    <div className='content'>
      <div className='columns is-variable is-6 is-multiline'>
        {location.search === '' || urlParam.type === 'all'
          ? allMappedProperties
          : mappedProperties}
        {urlParam.type !== 'all' ? renderViewAll() : ''}
      </div>
    </div>
  );
};

export default PropertiesRoll;
